import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { AutoCompleteAddress } from '@/hooks/useAutoCompleteAddress'
import { useGraphQLClient } from '@/hooks/useGraphQLClient'

const CLASSIFY_ADDRESS_MUTATION = gql`
  mutation ($input: ShipPointClassifyInput!) {
    classifyAddress(input: $input) {
      classifications {
        id
        addressType
      }
    }
  }
`

export interface ClassifyShipPoint {
  address1?: string
  address2?: string
  city?: string
  state?: string
  postalCode?: string
  countryCode?: string
}

export interface ClassifyAddressInput {
  shipPoints: ClassifyShipPoint[]
}

export interface Classification {
  id: string
  addressType: string
}

interface ClassifyAddressMutation {
  classifications: Classification[]
}

interface ClassifyAddressMutationResponse {
  classifyAddress: ClassifyAddressMutation
}

export const autoCompleteAddressToShipPoint = ({
  address_1,
  address_2,
  city,
  state,
  zip,
  country_code,
}: AutoCompleteAddress): ClassifyShipPoint => {
  return {
    address1: address_1,
    address2: address_2,
    city,
    state,
    postalCode: zip,
    countryCode: country_code,
  }
}

export const useClassifyAddressApi = (): UseMutationResult<
  ClassifyAddressMutation,
  Error,
  ClassifyAddressInput,
  unknown
> => {
  const client = useGraphQLClient()

  const classifyAddressApi = async (
    input: ClassifyAddressInput,
  ): Promise<ClassifyAddressMutation> => {
    const result = await client.request<ClassifyAddressMutationResponse>(
      CLASSIFY_ADDRESS_MUTATION,
      {
        input,
      },
    )

    return result.classifyAddress
  }

  return useMutation<ClassifyAddressMutation, Error, ClassifyAddressInput>({
    mutationFn: classifyAddressApi,
  })
}
